import { sha256 } from 'js-sha256';

import { QueryIntent } from './constants';

export const sha256Hash = (str: string): string => sha256(str);

export const extractUrlHostname = (sourceUrl: string) => {
	let url;
	try {
		url = new URL(sourceUrl);
	} catch {
		return undefined;
	}
	return url.hostname;
};

export const isHello = (cloudId: string): boolean => {
	return cloudId === 'a436116f-02ce-4520-8fbb-7301462a1674';
};

export const getAnswerCardType = (
	isReadingAids: boolean,
	smartAnswersRoute?: QueryIntent,
): string => {
	if (isReadingAids) {
		return 'definition';
	}

	switch (smartAnswersRoute) {
		case QueryIntent.PERSON:
			return 'people';
		case QueryIntent.TEAM:
			return 'team';
		case QueryIntent.AGENT:
			return 'agent';
		case QueryIntent.DATE:
			return 'date';
		case QueryIntent.LOCATION:
			return 'location';
		case QueryIntent.TOPIC:
			return 'topic';
		default:
			return 'SAIN';
	}
};
